import { Routes } from 'router/routes';
import { t } from 'i18next';

import type { IDropdownLinks } from './types';

interface IProps {
  showSmsBadge?: boolean;
}

export const headerLinks = (props?: IProps): IDropdownLinks[] => {
  const { showSmsBadge = false } = props ?? {};

  return [
    {
      label: t('links.forms'),
      exclude: true,
      dataCy: 'nav-forms',
      links: [
        [
          {
            label: t('links.baa'),
            link: Routes.BAA,
            dataCy: 'nav-forms__baa',
            target: '_blank',
          },
          {
            label: t('links.patientReferral'),
            link: Routes.patientReferral,
            dataCy: 'nav-forms__patient-referral',
            target: '_blank',
          },
          {
            label: t('links.w9'),
            link: Routes.W9,
            dataCy: 'nav-forms__w9',
            target: '_blank',
          },
        ],
      ],
    },
    {
      label: t('links.adminPanel'),
      dataCy: 'nav-admin',
      links: [
        [
          {
            label: t('links.clinics'),
            link: Routes.adminClinics,
            dataCy: 'nav-admin__clinics',
          },
          {
            label: t('links.clinicUsers'),
            link: Routes.adminUsers,
            dataCy: 'nav-admin__users',
          },
        ],
        [
          {
            label: t('links.agencies'),
            link: Routes.adminAgencyList,
            dataCy: 'nav-admin__agencies',
          },
          {
            label: t('links.agencyUsers'),
            link: Routes.adminAgencyDoctorList,
            dataCy: 'nav-admin__agency-users',
          },
        ],
        [
          {
            label: t('links.patients'),
            link: Routes.adminPatients,
            dataCy: 'nav-admin__patients',
          },
        ],
        [
          {
            label: t('links.actionTimeManagement'),
            link: Routes.actionTimeManagementTool,
            dataCy: 'nav-admin__action-time-management',
          },
        ],
      ],
    },
    {
      label: t('links.reports'),
      dataCy: 'nav-practice',
      links: [
        [
          {
            label: t('links.activity'),
            link: Routes.activityReport,
            dataCy: 'nav-practice__activity-report',
          },
          {
            label: t('links.adherence'),
            link: Routes.adherenceReport,
            dataCy: 'nav-practice__adherence-report',
          },
          {
            label: t('links.adherence30Days'),
            link: Routes.adherenceReportLast30Days,
            dataCy: 'nav-practice__adherence-30-days-report',
          },
          {
            label: t('links.clinicalMetrics'),
            link: Routes.clinicalMetrics,
            dataCy: 'nav-practice__clinical-metrics',
          },
        ],
        [
          {
            label: t('links.dailyReadingCompliance'),
            link: Routes.complianceReport,
            dataCy: 'nav-practice__compliance-report',
          },
          {
            label: t('links.interactiveTime'),
            link: Routes.interactiveTime,
            dataCy: 'nav-practice__interactive-time-report',
          },
          {
            label: t('links.medicareBilling'),
            link: Routes.medicareBilling,
            dataCy: 'nav-practice__medicare-billing',
          },
          {
            label: t('links.monthlyInteractionStatus'),
            link: Routes.interactionStatus,
            dataCy: 'nav-practice__monthly-interactive-status',
          },
          {
            label: t('links.apcmEligibilityReport'),
            link: Routes.apcmEligibilityReport,
            dataCy: 'nav-practice__apcm-eligibility-report',
          },
        ],
        [
          {
            label: t('links.onboardingStatus'),
            link: Routes.onboardingStatus,
            dataCy: 'nav-practice__onboarding-status',
          },
          {
            label: t('links.patientsStatus'),
            link: Routes.patientsStatusReport,
            dataCy: 'nav-practice__patients-status-report',
          },
          {
            label: t('links.performanceReview'),
            link: Routes.performanceReview,
            dataCy: 'nav-practice__performance-review',
          },

          {
            label: t('links.yesterdaysStatistics'),
            link: Routes.statisticsReport,
            dataCy: 'nav-practice__yesterdays-statistics',
          },
        ],
        [
          {
            label: t('links.rpmNewPatients'),
            link: Routes.newPatientsReport,
            dataCy: 'nav-practice__new-patients',
          },
          {
            label: t('links.normalReadingsReport'),
            link: Routes.normalReadingsReport,
            dataCy: 'nav-practice__normal-readings-report',
          },
          {
            label: t('links.ccmBilling'),
            link: Routes.ccmBillingReport,
            dataCy: 'nav-practice__ccm-billing',
          },
          {
            label: t('links.ccmInteractiveTime'),
            link: Routes.ccmInteractiveTimeReport,
            dataCy: 'nav-practice__ccm-interactive-time-report',
          },
        ],
        [
          {
            label: t('links.ccmOnboardingStatus'),
            link: Routes.ccmOnboardingStatus,
            dataCy: 'nav-practice__ccm-onboarding-status',
          },
          {
            label: t('links.ccmPatientStatus'),
            link: Routes.ccmStatusReport,
            dataCy: 'nav-practice__ccb-status-report',
          },
        ],
      ],
    },
    {
      label: t('links.dashboards'),
      dataCy: 'nav-patients',
      showBadge: showSmsBadge,
      links: [
        [
          {
            label: t('links.patientSearch'),
            link: Routes.patientDetails,
            dataCy: 'nav-patients__details',
          },
          {
            label: t('links.rpmDashboard'),
            link: Routes.overviewDashboard,
            dataCy: 'nav-rpm__dashboard',
          },
          {
            label: t('links.ccmDashboard'),
            link: Routes.ccm,
            dataCy: 'nav-ccm__dashboard',
          },
        ],
        [
          {
            label: t('links.interactiveTimeDashboard'),
            link: Routes.interactiveTimeDashboard,
            dataCy: 'nav-patients__interactive-time-dashboard',
          },
          {
            label: t('links.ccmAgentDashboard'),
            link: Routes.ccmAgentDashboard,
            dataCy: 'nav-patients__ccm-agent-dashboard',
          },
          {
            label: t('links.ccmConsole'),
            link: Routes.ccmConsole,
            dataCy: 'nav-ccm__console',
          },
        ],
        [
          {
            label: t('links.smsDashboard'),
            link: Routes.smsDashboard,
            dataCy: 'nav-patients__sms-dashboard',
            showBadge: showSmsBadge,
          },
          {
            label: t('links.smsDashboardMetrics'),
            link: Routes.smsDashboardMetrics,
            dataCy: 'nav-patients__sms-dashboard-metrics',
          },
          {
            label: t('links.smsAutoReplySettings'),
            link: Routes.smsAutoReplySettings,
            dataCy: 'nav-patients__sms-autoreply-settings',
          },
          {
            label: t('links.providerDashboard'),
            link: Routes.providerDashboard,
            dataCy: 'nav-patients__provider-dashboard',
          },
          // {
          //   label: t('links.patientTransfer'),
          //   link: Routes.patientTransfer,
          //   dataCy: 'nav-patients-tools__transfer',
          // },
        ],
        [
          {
            label: t('links.callDashboard'),
            link: Routes.callDashboard,
            dataCy: 'nav-patients__call-dashboard',
          },
          {
            label: t('links.callAgentsDashboard'),
            link: Routes.callAgentsDashboardMetrics,
            dataCy: 'nav-patients__call-agents-dashboard',
          },
        ],
      ],
    },

    {
      label: t('links.billingTools'),
      dataCy: 'nav-billing-tools',
      links: [
        [
          {
            label: t('links.claimsAthena'),
            link: Routes.billingClaimsAthena,
            dataCy: 'nav-claims__athena',
          },
          {
            label: t('links.claimsEpic'),
            link: Routes.billingClaimsEpic,
            dataCy: 'nav-claims__epic',
          },
        ],
      ],
    },
    {
      label: t('links.callTools'),
      dataCy: 'nav-call-tools',
      links: [
        [
          {
            label: t('links.untrackedInboundCalls'),
            link: Routes.untrackedInboundCalls,
            dataCy: 'nav-call-tools__untracked-inbound-calls',
          },
          {
            label: t('links.callHistoryManagement'),
            link: Routes.callHistoryManagement,
            dataCy: 'nav-call-tools__call-history-management',
          },
          {
            label: t('links.linkCallReadingTool'),
            link: Routes.linkCallReadingTool,
            dataCy: 'nav-call-tools__link-call-reading-tool',
          },
        ],
      ],
    },
    {
      label: t('links.adherenceSettings'),
      dataCy: 'nav-adherence-settings',
      links: [
        [
          {
            label: t('links.cohortsInactiveDays'),
            link: Routes.adherenceSettingsCohortsInactiveDays,
            dataCy: 'nav-adherence-settings__cohorts-inactive-days',
          },
          {
            label: t('links.queueLimits'),
            link: Routes.adherenceSettingsQueueLimits,
            dataCy: 'nav-adherence-settings__queue-limits',
          },
        ],
      ],
    },
  ];
};
